<template>
  <div :class="['image-preview-item', extraClasses]">
    <span v-if="description" class="image-preview-description">{{description}}</span>
    <loading-icon v-if="imageDeleting"></loading-icon>
    <img :src="src"
         :alt="[alt ? alt : description]"
         v-else
         class="image-preview thumbnail" />
    <div v-if="deleteText && !imageDeleting"
         v-html="deleteText"
         :class="['delete-attachment link-delete', deleteClasses]"
         @click="deleteAttachment"></div>
    <small v-if="errorMessage" class='file-warning error-label form-message'>{{errorMessage}}</small>
  </div>
</template>

<script>
  import axiosConfig from '../../config/axios'
  import LoadingIcon from './LoadingIcon'

  export default {
    props: {
      alt: String,
      deleteClasses: String,
      deleteText: String,
      description: String,
      extraClasses: String,
      image: Object,
      src: String,
      uuid: String,
    },

    name: 'ImagePreview',

    components: {
      LoadingIcon
    },

    data() {
      return {
        errorMessage: null,
        imageDeleting: false
      };
    },

    methods: {
      deleteAttachment() {
        this.imageDeleting = true
        axiosConfig.delete(`/api/v3/attachments/${this.uuid}`)
          .then((response) => {
            if (response.data.success) {
              this.$emit('reload')
              this.errorMessage = null
            } else {
              this.errorMessage = 'could not delete image'
            }
            this.imageDeleting = false
          })
          .catch((error) => {
            this.errorMessage = `issue deleting image. ${error}`
            this.imageDeleting = false
          })
      },
    },

    watch: {
      imageDeleting: function () {
        this.$emit('adviseLoading', this.imageDeleting)
      },
    },
  }
</script>